module.exports = __webpack_public_path__ + "img/bluCapital.3a1bb244.png";